import * as React from "react"

const PricingTagGroup = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.3 239.12" {...props}>
    <title>{"home-4-pricing-tag-2"}</title>
    <path
      d="M12.09 166.78V79.66h136L173 123.23l-24.95 43.55Zm146.74-43.56a6.85 6.85 0 1 0-6.85 6.85 6.85 6.85 0 0 0 6.85-6.85Z"
      transform="translate(-8 -9.66)"
      fill="#3e4c5e"
      opacity={0.4}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M0 149.46V62.34h136l25 43.57-25 43.55Zm146.74-43.56a6.85 6.85 0 1 0-6.85 6.85 6.85 6.85 0 0 0 6.85-6.85Z"
      fill="#317d6e"
    />
    <path
      d="M0 149.46V62.34h136l25 43.57-25 43.55Zm146.74-43.56a6.85 6.85 0 1 0-6.85 6.85 6.85 6.85 0 0 0 6.85-6.85Z"
      fill="#4ead90"
    />
    <path
      d="m134.22 65.34 23.28 40.57-23.28 40.55H3V65.34h131.22m5.67 50.41a9.85 9.85 0 1 0-9.84-9.86 9.87 9.87 0 0 0 9.84 9.85M136 62.34H0v87.12h136l25-43.55Zm3.93 50.41a6.85 6.85 0 1 1 6.85-6.85 6.85 6.85 0 0 1-6.85 6.85Z"
      fill="#b9d816"
    />
    <path
      d="m136 62.34 24.95 43.57L136 149.46H97.29l25-43.55-25-43.57Zm10.78 43.56a6.85 6.85 0 1 0-6.85 6.85 6.85 6.85 0 0 0 6.85-6.85Z"
      fill="#b9d816"
    />
    <path
      fill="#b9d816"
      d="m61.47 62.34 24.94 43.57-24.94 43.55h28.91l24.95-43.55-24.95-43.57H61.47z"
    />
    <path
      fill="#b9d816"
      d="m25.64 62.34 24.94 43.57-24.94 43.55H44.8l24.95-43.55L44.8 62.34H25.64z"
    />
    <path
      d="m141.07 107.61-.78-.62c3.48-4.29 21-7.4 41.71-7.4v1c-20.08 0-37.68 3.02-40.93 7.02Z"
      fill="#fff"
    />
    <path
      d="M182 115.89c-20.84 0-42.4-3.42-42.4-9.15s21.56-9.15 42.4-9.15 42.4 3.42 42.4 9.15-21.56 9.15-42.4 9.15Zm0-17.3c-24.76 0-41.4 4.21-41.4 8.15s16.64 8.15 41.4 8.15 41.4-4.21 41.4-8.15-16.64-8.15-41.4-8.15Z"
      fill="#b9d816"
    />
    <path
      d="M79.39 100.39V17h130.19l23.84 41.7-23.88 41.69Zm140.47-41.7a6.56 6.56 0 1 0-6.56 6.56 6.56 6.56 0 0 0 6.56-6.56Z"
      transform="translate(-8 -9.66)"
      fill="#3e4c5e"
      opacity={0.4}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M67.47 83.4V0h130.19l23.88 41.71-23.92 41.69Zm140.47-41.7a6.56 6.56 0 1 0-6.56 6.56 6.56 6.56 0 0 0 6.56-6.56Z"
      fill="#317d6e"
    />
    <path
      d="M67.47 83.4V0h130.19l23.88 41.71-23.92 41.69Zm140.47-41.7a6.56 6.56 0 1 0-6.56 6.56 6.56 6.56 0 0 0 6.56-6.56Z"
      fill="#4ead90"
    />
    <path
      d="m196 2.87 22.28 38.84L196 80.53H70.34V2.87H196m5.42 48.26a9.43 9.43 0 1 0-9.42-9.44 9.44 9.44 0 0 0 9.42 9.43M197.62 0H67.47v83.4h130.19l23.88-41.69Zm3.76 48.26a6.56 6.56 0 1 1 6.56-6.56 6.56 6.56 0 0 1-6.56 6.56Z"
      fill="#b9d816"
    />
    <path
      d="m197.62 0 23.89 41.71-23.89 41.69h-37l23.89-41.69L160.6 0Zm10.32 41.7a6.56 6.56 0 1 0-6.56 6.56 6.56 6.56 0 0 0 6.56-6.56Z"
      fill="#b9d816"
    />
    <path
      fill="#b9d816"
      d="m126.31 0 23.88 41.71-23.88 41.69h27.68l23.88-41.69L153.99 0h-27.68z"
    />
    <path
      fill="#b9d816"
      d="m92.02 0 23.87 41.71L92.02 83.4h18.34l23.88-41.69L110.36 0H92.02z"
    />
    <path
      d="m202.53 43.34-.78-.63c3.34-4.1 20.13-7.08 39.94-7.08v1c-19.22.01-36.05 2.9-39.16 6.71Z"
      fill="#fff"
    />
    <path
      d="M241.69 51.28c-20 0-40.61-3.28-40.61-8.78s20.65-8.78 40.61-8.78 40.61 3.29 40.61 8.78-20.64 8.78-40.61 8.78Zm0-16.56c-23.69 0-39.61 4-39.61 7.78s15.92 7.78 39.61 7.78 39.61-4 39.61-7.78-15.91-7.78-39.61-7.78Z"
      fill="#b9d816"
    />
    <path
      d="M168.7 248.78V181h105.86L294 214.88l-19.42 33.9Zm114.22-33.91a5.33 5.33 0 1 0-5.33 5.33 5.33 5.33 0 0 0 5.33-5.33Z"
      transform="translate(-8 -9.66)"
      fill="#3e4c5e"
      opacity={0.4}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M157.51 233.16v-67.82h105.87l19.42 33.92-19.45 33.9Zm114.23-33.91a5.33 5.33 0 1 0-5.33 5.33 5.33 5.33 0 0 0 5.33-5.33Z"
      fill="#317d6e"
    />
    <path
      d="M157.51 233.16v-67.82h105.87l19.42 33.92-19.45 33.9Zm114.23-33.91a5.33 5.33 0 1 0-5.33 5.33 5.33 5.33 0 0 0 5.33-5.33Z"
      fill="#4ead90"
    />
    <path
      d="m262 167.68 18.13 31.58L262 230.82H159.85v-63.14H262m4.42 39.24a7.67 7.67 0 1 0-7.66-7.68 7.68 7.68 0 0 0 7.66 7.67m-3.07-41.57H157.51v67.82h105.87l19.42-33.9Zm3.06 39.24a5.33 5.33 0 1 1 5.33-5.33 5.33 5.33 0 0 1-5.33 5.33Z"
      fill="#b9d816"
    />
    <path
      d="m263.35 165.34 19.42 33.92-19.42 33.9h-30.1l19.42-33.9-19.42-33.92Zm8.39 33.91a5.33 5.33 0 1 0-5.33 5.33 5.33 5.33 0 0 0 5.33-5.33Z"
      fill="#b9d816"
    />
    <path
      fill="#b9d816"
      d="m205.36 165.34 19.42 33.92-19.42 33.9h22.51l19.42-33.9-19.42-33.92h-22.51z"
    />
    <path
      fill="#b9d816"
      d="m177.47 165.34 19.42 33.92-19.42 33.9h14.92l19.42-33.9-19.42-33.92h-14.92z"
    />
    <path
      d="m267.41 200.65-.78-.63c2.73-3.36 16.42-5.79 32.56-5.79v1c-15.61 0-29.27 2.33-31.78 5.42Z"
      fill="#fff"
    />
    <path
      d="M299.19 207.14c-16.06 0-33.12-2.54-33.12-7.24s17.06-7.23 33.12-7.23 33.11 2.53 33.11 7.23-17.06 7.24-33.11 7.24Zm0-13.47c-18.93 0-32.12 3.28-32.12 6.23s13.19 6.24 32.12 6.24 32.11-3.29 32.11-6.24-13.18-6.23-32.11-6.23Z"
      fill="#b9d816"
    />
  </svg>
)

export default PricingTagGroup
